module.exports = __webpack_public_path__ + "img/NU.971e5c2f.svg";